import Vue from 'vue'

const state = {
  listaMunicipiosProgramas: [],
}

const mutations = {
  setMunicipiosProgramas (state, data) {
    state.listaMunicipiosProgramas = data
  },
}


const actions = {
  buscarMunicipiosProgramas (context, id) {
    Vue.http.get('api/municipios-programas').then(response => {
      context.commit('setMunicipiosProgramas', response.data.data.data)
    })
  },
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/municipiosprogramas.js